import type { StateCreator } from 'zustand';

export interface UserSettingsSliceState {
  progressBar: boolean;
  progressBarTitle: string;
  onboardingStepName: string;
  progressBarTourStepsTotal: number;
  userSettingsTour: boolean;
  setUserSettingsTour: (value: boolean) => void;
  setUserSettingsTourStart: () => void;
  setUserSettingsTourFinish: () => void;
}

type StateCreatorUserSettingsTour = StateCreator<UserSettingsSliceState>;

const initialStates = {
  progressBar: false,
  progressBarTitle: 'Convidar usuários ao painel e definir sua função',
  onboardingStepName: '',
  progressBarTourStepsTotal: 1,
  userSettingsTour: false,
};

const createUserSettingsTourSlice: StateCreatorUserSettingsTour = (set) => ({
  ...initialStates,
  setUserSettingsTour: (userSettingsTour: boolean) => set({ userSettingsTour }),
  setUserSettingsTourStart: () =>
    set({
      ...initialStates,
      progressBar: true,
      onboardingStepName: 'Invite Users',
      userSettingsTour: true,
    }),
  setUserSettingsTourFinish: () =>
    set({
      ...initialStates,
      progressBar: true,
    }),
});

export default createUserSettingsTourSlice;
